import React from "react";

export const IconNodataBoxSvg = ({ ...props }) => {
	return (
		<svg width="62" height="72" viewBox="0 0 62 72" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
			<path
				opacity="0.5"
				d="M5.89062 56.3897C5.89062 56.3897 19.6328 62.8065 25.0845 65.2692C29.4028 67.2198 51.6382 73.4597 54.2872 71.686C56.9362 69.9123 62.7848 65.0442 60.8539 61.709C58.9231 58.3738 48.7685 52.3853 43.9121 51.5103C39.0557 50.6353 25.1693 54.6129 25.1693 54.6129L13.3246 56.6328L5.89062 56.3897Z"
				fill="url(#paint0_linear_2465_116539)"
			/>
			<path d="M16.0751 27.6984L0.761551 38.8799L4.84469 29.367L20.1807 19.6987L16.0751 27.6984Z" fill="#C5D0D9" />
			<path d="M4.5918 29.5641L20.1825 19.8721V46.3048L5.89102 56.2549L4.5918 29.5641Z" fill="#A0AAB5" />
			<path d="M20.1807 19.8721L44.0864 25.4259V51.8683L20.1807 46.3145V19.8721Z" fill="#8E99A3" />
			<path d="M4.5918 29.563L29.0173 35.2314V61.6738L5.89102 56.4003L4.5918 29.563Z" fill="#DAE2EB" />
			<path d="M28.4971 35.2428L44.0878 25.5508V51.9836L28.4971 61.6756V35.2428Z" fill="#C5D0D9" />
			<mask id="mask0_2465_116539" maskUnits="userSpaceOnUse" x="28" y="25" width="17" height="37">
				<path d="M28.4971 35.2428L44.0878 25.5508V51.9836L28.4971 61.6756V35.2428Z" fill="white" />
			</mask>
			<g mask="url(#mask0_2465_116539)">
				<rect x="34.2871" y="23.3472" width="4.89994" height="40.5302" fill="#C5D0D9" />
			</g>
			<path d="M35.5098 43.0961L50.8457 33.4279L43.835 25.5498L28.499 35.2181L35.5098 43.0961Z" fill="#DAE2EB" />
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M35.2273 13.3523C35.4757 12.8304 35.7258 12.2901 35.9776 11.7314L36.3887 11.9142C36.1357 12.4755 35.8843 13.0186 35.6346 13.5434L35.2273 13.3523ZM33.6084 16.5386C33.8829 16.0357 34.1596 15.509 34.4386 14.9584L34.8409 15.1594C34.5599 15.714 34.2811 16.2448 34.0044 16.7517L33.6084 16.5386ZM32.7246 18.0873C32.4045 18.623 32.0877 19.1251 31.7741 19.5935L32.1492 19.8411C32.4671 19.3662 32.788 18.8577 33.1119 18.3155L32.7246 18.0873ZM29.5777 22.3783C29.9576 21.987 30.3431 21.5405 30.7342 21.0387L31.0904 21.3124C30.6897 21.8266 30.2936 22.2853 29.9019 22.6887L29.5777 22.3783ZM28.2546 23.5344C27.7281 23.909 27.2154 24.1681 26.7168 24.313L26.8433 24.7422C27.3934 24.5824 27.9512 24.3005 28.517 23.8979L28.2546 23.5344ZM23.5402 23.5809C24.0355 23.9775 24.539 24.2373 25.0514 24.3626L24.9438 24.7969C24.3643 24.6552 23.802 24.3651 23.2574 23.9291L23.5402 23.5809ZM22.3265 22.3117C22.2986 22.2754 22.2707 22.2386 22.2428 22.2014C21.8803 21.7168 21.6169 21.2569 21.449 20.8225L21.0285 20.9828C21.212 21.4574 21.4955 21.9524 21.8813 22.4682C21.9104 22.507 21.9394 22.5453 21.9686 22.5832L22.3265 22.3117ZM22.2187 17.8103C21.7322 18.2093 21.4193 18.6674 21.2916 19.1784L20.8545 19.0707C21.0068 18.461 21.3747 17.9225 21.9319 17.4655L22.2187 17.8103ZM23.7254 16.9718C24.2322 16.7753 24.802 16.615 25.42 16.4941L25.3328 16.0553C24.6897 16.1812 24.0943 16.3486 23.5615 16.5552L23.7254 16.9718ZM28.9439 16.2384C28.3446 16.2172 27.7475 16.227 27.166 16.2677L27.1343 15.821C27.7318 15.7792 28.3449 15.7691 28.9599 15.7909L28.9439 16.2384ZM30.737 16.3952C31.3407 16.4806 31.9247 16.5975 32.4764 16.744L32.5928 16.312C32.0234 16.1607 31.4216 16.0402 30.8005 15.9524L30.737 16.3952ZM35.6443 18.2191C35.2324 17.8863 34.7299 17.5875 34.1498 17.3279L34.3349 16.9201C34.9489 17.1949 35.4846 17.5135 35.9285 17.8722L35.6443 18.2191ZM36.7171 19.5618C36.8257 19.8125 36.8953 20.0737 36.9246 20.3453C36.9556 20.6327 36.9663 20.9215 36.9568 21.2119L37.4069 21.2265C37.4172 20.9154 37.4057 20.6057 37.3724 20.2977C37.3383 19.9813 37.2572 19.6766 37.1308 19.385L36.7171 19.5618ZM35.9973 24.5445C36.2871 24.0016 36.5115 23.4643 36.6706 22.9327L37.1023 23.0602C36.9345 23.6209 36.6987 24.1855 36.3952 24.754L35.9973 24.5445ZM35.0426 26.0406C34.7094 26.4912 34.3327 26.9454 33.9125 27.4032L34.2454 27.7045C34.676 27.2354 35.0628 26.769 35.4057 26.3053L35.0426 26.0406ZM31.3276 29.8221C31.8057 29.429 32.2533 29.0384 32.6706 28.6501L32.9786 28.9764C32.5544 29.3711 32.0999 29.7678 31.6148 30.1666L31.3276 29.8221ZM29.908 30.9282C29.4451 31.2722 28.9594 31.6179 28.4509 31.9653L28.7062 32.3338C29.2195 31.9831 29.7101 31.6339 30.1779 31.2863L29.908 30.9282ZM26.0023 33.545C26.3223 33.3494 26.6353 33.1543 26.9413 32.9598L27.1841 33.3365C26.8758 33.5325 26.5606 33.7289 26.2384 33.9259L26.0023 33.545Z"
				fill="#C7D0D9"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M43.7286 0.0106297C43.12 0.195388 30.5191 7.68214 30.5191 7.68214L34.1963 7.95443L36.8094 10.8222C36.8094 10.8222 44.3372 -0.174129 43.7286 0.0106297Z"
				fill="#E7EDF3"
			/>
			<mask id="mask1_2465_116539" maskUnits="userSpaceOnUse" x="30" y="0" width="14" height="11">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M43.7286 0.0106297C43.12 0.195388 30.5191 7.68214 30.5191 7.68214L34.1963 7.95443L36.8094 10.8222C36.8094 10.8222 44.3372 -0.174129 43.7286 0.0106297Z"
					fill="white"
				/>
			</mask>
			<g mask="url(#mask1_2465_116539)">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M34.1953 7.95457L43.7275 0.0107684L36.8083 10.8224L34.1953 7.95457Z"
					fill="#CFD7DF"
				/>
			</g>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M41.8347 8.68488L37.4159 8.22626L43.7317 0.086787L41.8347 8.68488Z"
				fill="#E7EDF3"
			/>
			<defs>
				<linearGradient
					id="paint0_linear_2465_116539"
					x1="3.87131"
					y1="58.6148"
					x2="8.27632"
					y2="75.3919"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#DBDEE2" />
					<stop offset="1" stopColor="#FBFBFB" />
				</linearGradient>
			</defs>
		</svg>
	);
};
